import Image from 'next/image';
import Link from 'next/link';

import applePay from 'public/icons/apple-pay.svg';
import blik from 'public/icons/blik.svg';
import certify from 'public/icons/certify-light.svg';
import diamond from 'public/icons/diamond.svg';
import googlePay from 'public/icons/google-pay.svg';
import mastercard from 'public/icons/mastercard.svg';
import visa from 'public/icons/visa.svg';
import patynaLogo from 'public/images/patyna_logo_light.svg';

import styles from './styles.module.scss';

const FooterCheckout = () => {
  return (
    <footer className={styles.container}>
      <div className={styles.left}>
        <div className={styles.footerNav}>
          <div className={styles.logoWrapper}>
            <Link href="/">
              <Image
                src={patynaLogo}
                alt="Patyna - sklep z meblami i dekoracjami vintage"
                width={54}
              />
            </Link>
            <p>Wybierz vintage!</p>
          </div>
        </div>
      </div>
      <div className={styles.center}>
        <div className={styles.paragraphBox}>
          <Image src={certify} height={24} alt="Ikona gwarancji" />
          <p>Gwarancja bezpiecznej dostawy</p>
        </div>
        <div className={styles.paragraphBox}>
          <Image src={diamond} height={24} alt="Ikona autentyczności" />
          <p>Tylko oryginalne produkty od zweryfikowanych sprzedawców</p>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.topRow}>
          <Link href="/regulamin">Regulamin</Link>
          <Link href="/polityka-prywatnosci">Polityka prywatności</Link>
        </div>
        <div className={styles.bottomRow}>
          <div className={styles.paymentMethods}>
            <Image src={visa} height={18} alt="Visa" />
            <Image src={mastercard} height={20} alt="Mastercard" />
            <Image src={blik} height={20} alt="BLIK" />
            <Image src={applePay} height={20} alt="Apple Pay" />
            <Image src={googlePay} height={20} alt="Google Pay" />
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterCheckout;
